import { RoleList } from '@unistocks/features/admin/components/role-management/role-list';
import { t } from '@unistocks/shared/localization/index.ts';
import Head from 'expo-router/head';

export default function RoleManagementPage() {
  return (
    <>
      <Head>
        <title>{t('AbpIdentity::Roles')}</title>
      </Head>
      <RoleList />
    </>
  );
}
